import { createContext, useContext } from 'react';
import { getTranslation } from '@/lib/i18n';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const language = 'de';
  const setLanguage = () => {};
  const t = (key) => getTranslation('de', key);
  const languages = [];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
